/* HUSSIENI HOME — Ship-to selector and currency note

   1. Changing the "Ship to" select submits its localization form, so no
      separate button is needed. A <noscript> button covers the rest.

   2. Prices are charged in EGP. A display-only converter app may show them
      in another currency; when it does, every [data-hh-fx-note] is shown.
      Apps expose their choice in different places, so the common ones are
      checked, and an app integration can also announce it directly:

        document.dispatchEvent(new CustomEvent('hh:currency', { detail: 'SAR' }));
*/
(function () {
  var BASE = 'EGP';

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-hh-region]');
    if (select && select.form) select.form.submit();
  });

  function reveal(code) {
    if (!code || String(code).toUpperCase() === BASE) return;
    document.querySelectorAll('[data-hh-fx-note]').forEach(function (note) {
      note.hidden = false;
    });
  }

  function detect() {
    var code = null;
    try {
      if (window.Currency) code = window.Currency.currentCurrency || window.Currency.current || null;
    } catch (e) {}
    if (!code) {
      try {
        code = localStorage.getItem('currency') || localStorage.getItem('currentCurrency');
      } catch (e) {}
    }
    reveal(code);
  }

  document.addEventListener('hh:currency', function (event) { reveal(event.detail); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detect);
  } else {
    detect();
  }
  /* Converter apps usually load after the page; look once more when they have. */
  window.addEventListener('load', function () { setTimeout(detect, 1500); });
})();
